// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__AO3V+","spinAnimation":"style_spinAnimation__DIsa5"};